import ApiService from "../../_services/ApiService";
import React from "react";
import { RouteComponentProps } from "react-router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { time } from "console";
import { DateScroll } from "../../_components/date-scroll";
import WeeklyTimetable from "./weekly-timetable.component";
import Sidebar from "../../components/Sidebar/Sidebar";

import "./timetable.css";

// @Component({
//   selector: 'page-timetable',
//   templateUrl: './timetable.component.html',
//   styleUrls: ['./timetable.component.css']
// })

interface Myprops extends RouteComponentProps {}

interface Mystate {
  timetables: any;
  datesConfig: any;
  selectedDate: Date;
  selectedMode: "daily" | "weekly";
  sidebarOpen: boolean;
}
export class Timetable extends React.Component<Myprops, Mystate> {
  state: Mystate = {
    timetables: [],
    datesConfig: {},
    selectedDate: new Date(),
    selectedMode: "daily",
    sidebarOpen: false,
  };

  constructor(props: Myprops) {
    super(props);
    this.onSelectDate = this.onSelectDate.bind(this);
    this.initDateConfig();
    this.getTimeTables();
  }
  datesConfig: any = {};
  initDateConfig() {
    var today = new Date();
    console.log(today);
    this.setState({ selectedDate: today });

    var startDate = new Date(today); //YYYY-MM-DD
    var endDate = new Date(today); //YYYY-MM-DD
    console.log(startDate);
    startDate.setDate(today.getDate() - 1);
    endDate.setDate(today.getDate() + 30);
    this.datesConfig = {
      startDate: startDate,
      endDate: endDate,
      defaultSeletedDate: today,
    };
    // this.setState({datesConfig });
    console.log("DateConfig : " + JSON.stringify(this.state.datesConfig));
  }

  onSelectDate(dt: any): void {
    console.log(JSON.stringify(dt));
    this.setState({ selectedDate: dt.dateObject });
    setTimeout(() => {
      console.log(this.state.selectedDate);
      this.getTimeTables();
    }, 0);
  }

  getTimeTables() {
    console.log("In getTimeTables...");
    this.setState({ timetables: [] });
    //this.showLoading();
    console.log(this.state.selectedDate);
    var dd: any = this.state.selectedDate.getDate();
    var mm: any = this.state.selectedDate.getMonth() + 1;
    var yyyy = this.state.selectedDate.getFullYear();
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    var startDate = dd + "/" + mm + "/" + yyyy;
    console.log(startDate);
    var endDate = startDate;
    let userId = JSON.parse(localStorage.getItem("currentUser")).userId;
    let timetableData: any = {
      startDate: startDate,
      endDate: endDate,
      instructorId: null,
      userId: userId,
    };
    ApiService.getInstructorTimetable(timetableData).then((res) => {
      const respData = res.data;
      console.log(
        "getInstructorTimetable(), Response : " + JSON.stringify(respData)
      );
      //alert(JSON.stringify(respData));
      if (respData.status <= 0) {
        //ErrorCB
        //this.connectionError();
      } else {
        //SuccessCB
        //this.hideLoading();
        if (respData.status == 1) {
          if (respData.data.timeTableDataBeans.length > 0) {
            //this.hideLoading();
            this.initTimetables(respData.data.timeTableDataBeans);
          } else {
            //this.showError("No Timetables found for selected date.");
          }
        } else {
          //this.showError(respData.message);
        }
      }
    });
  }

  initTimetables(timetables: any) {
    console.log("In initTimetables...");
    for (let i = 0; i < timetables.length; i++) {
      let _day = timetables[i].dayOfweek;
      timetables[i].dayOfweek = _day.substring(0, 3);
    }
    this.setState({ timetables: timetables });
  }

  goBack() {
    this.props.history.goBack();
  }

  changeMode = (mode: "daily" | "weekly") => {
    this.setState({
      selectedMode: mode,
    });
  };

  render() {
    return (
      <>
      <Sidebar isOpen={this.state.sidebarOpen} onClose={() => this.setState({ sidebarOpen: false })} />
      <div className="timetable">
        <button
          className="timetable-menu-btn"
          onClick={() => this.setState({ sidebarOpen: !this.state.sidebarOpen })}
          title="Toggle menu"
        >
          ☰
        </button>
        <div className="card">
          <div className="card-header timetable-header">
            <h2 className="time-table-heading">
              <span className="time-table-back">
              <FontAwesomeIcon
                icon={faArrowLeft}
                onClick={() => this.goBack()}
                />
                </span>
              Timetable
            </h2>
            <div className="timetable-button-container">
              <span
                onClick={() => this.changeMode("daily")}
                className={`timetable-button ${
                  this.state.selectedMode === "daily" ? "active" : ""
                }`}
              >
                Daily
              </span>
              <span
                onClick={() => this.changeMode("weekly")}
                className={`timetable-button ${
                  this.state.selectedMode === "weekly" ? "active" : ""
                }`}
              >
                Weekly
              </span>
            </div>
          </div>
        </div>
        {this.state.selectedMode === "daily" ? (
          <>
            <div className="card">
              <div className="card-body">
                <DateScroll
                  datesConfig={this.datesConfig}
                  notify={this.onSelectDate}
                ></DateScroll>
              </div>
            </div>
            <div className="card">
              <div className="card-body">
                {this.state.timetables.map((timetable, i) => (
                  <div key={i}>
                    {timetable.activitySlotDataBeans.map((activitySlot, i) => (
                      <div className="timelist bg-primary" key={i}>
                        <h3 className="label-batch text-warning">
                          {activitySlot.batchNames || activitySlot.batchName}
                        </h3>
                        <h4 className="label-topic">
                          {activitySlot.topicName}
                        </h4>
                        <p className="label-room">
                          {activitySlot.roomName} [{activitySlot.startTime} -{" "}
                          {activitySlot.endTime}]
                        </p>
                      </div>
                    ))}
                  </div>
                ))}

                {this.state.timetables.length == 0 && (
                  <div className="timelist bg-primary">
                    <h4 className="text-center text-warning">
                      No timetable found!
                    </h4>
                  </div>
                )}
              </div>
            </div>
          </>
        ) : (
          <WeeklyTimetable />
        )}
      </div>
      </>
    );
  }
}
